export default {
  title: "Pipeline",
  activeDrivers_one: "{{count}} active driver",
  activeDrivers_other: "{{count}} active drivers",
  loadFailed: "Could not load the pipeline.",
  conflictTitle: "Changed by someone else",
  conflictDesc: "{{who}} just updated {{name}}. The board was refreshed.",
  conflictDescAnon: "Someone updated {{name}}. The board was refreshed.",
  network: "Could not reach the server. Check your connection.",
  scope: { my: "My drivers", myBranch: "My branch", branch: "Branch #{{id}}", all: "All branches" },
  noDrivers: "No drivers",
  more: "+{{n}} more · use filters",
  rejectZone: "Drop here to reject · reason required",
  rejectZoneOptional: "Drop here to reject",
  hired: "Hired · {{n}} →",
  filters: {
    recruiter: "Recruiter",
    allRecruiters: "All recruiters",
    job: "Carrier / job",
    allCarriers: "All carriers",
    source: "Source",
    search: "Filter by name or phone",
  },
  card: {
    overdue: "{{label}} · overdue",
    next: "Next: {{label}} · {{when}}",
    firstCall: "Next: First call",
    collectDocs: "Next: Collect docs",
    waitCarrier: "Wait for carrier",
    waitBg: "Wait for background check",
    confirmOrientation: "Confirm orientation date",
    cdlExp: "CDL exp {{date}}",
    cdlNone: "CDL exp —",
    daysInStage: "{{n}} days in this stage",
    days: "{{n}}d",
    unassigned: "Unassigned",
  },
  move: {
    title: "Move to {{status}}",
    which: "{{name}} · which job?",
    markHired: "Mark hired",
    submit: "Submit",
    noJobs: "No open jobs. Ask your manager to add one in Jobs.",
    onlyOpen: "Only open jobs are listed.",
    startDate: "Start date",
    evidence: "Evidence / note",
    note: "Submission note",
    hiredHint: "Hired is counted after manager approval (Approvals).",
    placeholderHired: "Carrier confirmed by email…",
    placeholderNote: "Clean MVR, 2 yrs dry van",
  },
  reject: {
    title: "Reject {{name}}",
    titlePlain: "Reject",
    desc: "The driver leaves the pipeline. Reason is required and goes to the status history.",
    rejectDriver: "Reject driver",
    notInterested: "Mark not interested",
    rejectedOpt: "Rejected (by carrier or us)",
    notInterestedOpt: "Not interested",
    reason: "Reason",
    chooseReason: "Choose a reason…",
    note: "Note",
    notePlaceholder: "Optional details for the history",
  },
};
